import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class LoadingSpinnerService {

  loadingStatus: boolean = false;
  loaderActive = new Subject<any>();

  spinnerLoadingList = [];

  changeLoadingStatus() {
    if (this.spinnerLoadingList.length) {
      this.loadingStatus = true;
      this.loaderActive.next(this.loadingStatus);
    } else {
      this.loadingStatus = false;
      this.loaderActive.next(this.loadingStatus);
    }
  }

  spinnerLoadingListAdd(loadingInstance) {
    this.spinnerLoadingList.push(loadingInstance);
    this.changeLoadingStatus();
  }
  spinnerLoadingListRemove(loadingInstance) {
    this.spinnerLoadingList = this.spinnerLoadingList.filter(element => element != loadingInstance);
    this.changeLoadingStatus();
  }

  spinnerLoadingListAddPromise(loadingInstance) {
    const promise = new Promise((resolve, reject) => {
      this.spinnerLoadingListAdd(loadingInstance);
      this.changeLoadingStatus();
      setTimeout(() => { resolve() }, 300)
    });
    return promise
  }

  performWork(action: () => void) {
    const id = new Date().getTime();
    this.spinnerLoadingListAdd(id);
    this.changeLoadingStatus();
    setTimeout(() => {
      action();
      this.spinnerLoadingListRemove(id);
    }, 100);
  }

  async performAsyncWork(action: () => Promise<any>) {
    const id = new Date().getTime();
    this.spinnerLoadingListAdd(id);
    this.changeLoadingStatus();
    await action();
    this.spinnerLoadingListRemove(id);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/loading-spinner.service.ts